/*
 * @Author: 周泽飞 zefei.zhou@tongdun.net
 * @Date: 2023-01-29 16:27:31
 * @LastEditors: 周泽飞 zefei.zhou@tongdun.net
 * @LastEditTime: 2023-02-08 15:51:29
 * @FilePath: /tntd/packages/tntd/src/exception/index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import LocaleReceiver from 'antd/lib/locale-provider/LocaleReceiver'
import classNames from 'classnames'
import React from 'react'
import { ConfigConsumer } from 'antd/lib/config-provider'
import { default as Empty } from '../empty'

export interface ExceptionProps {
  type?: '403' | '404' | '500'
  title?: string
  desc?: string
  dom?: React.ReactNode
  className?: string
  style: object
  locale?: {
    '403'?: string
    '404'?: string
    '500'?: string
  }
}

export const ExceptionDescMap: Record<
  NonNullable<ExceptionProps['type']>,
  keyof NonNullable<ExceptionProps['locale']> | undefined
> = {
  '403': '403',
  '404': '404',
  '500': '500',
}

export function Exception({
  type = '404',
  style,
  title,
  desc,
  dom,
  className,
}: ExceptionProps): JSX.Element {
  return (
    <ConfigConsumer>
      {({ getPrefixCls }) => {
        const prefixCls = getPrefixCls('exception')
        return (
          <LocaleReceiver componentName="Exception">
            {(locale) => {
              const defaultDescription = ExceptionDescMap[type]
                ? (locale as Record<string, string>)[ExceptionDescMap[type]!]
                : undefined

              return (
                <div className={classNames(prefixCls, className)} style={style || {}}>
                  <Empty
                    type={type}
                    size="ultra"
                    description={
                      <div className={`${prefixCls}-desc`}>
                        <h1>{title || type}</h1>
                        <div>{desc || defaultDescription}</div>
                      </div>
                    }
                  />
                  {!!dom && dom}
                </div>
              )
            }}
          </LocaleReceiver>
        )
      }}
    </ConfigConsumer>
  )
}
